import { getUserId } from '../analytics';
import { safeLocalStorageGetItem, safeLocalStorageSetItem } from './safeStorage';

export const MONDIALI_OPENING_CEREMONY_START_UTC_MS = Date.parse('2026-06-11T00:00:00Z');
export const MONDIALI_OPENING_CEREMONY_END_UTC_MS = Date.parse('2026-06-14T00:00:00Z');
export const MONDIALI_OPENING_CEREMONY_OPEN_DELAY_MS = 700;

const MONDIALI_OPENING_CEREMONY_SEEN_KEY_PREFIX = 'mondiali-opening-ceremony-seen-v1';

const isNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;

const normalizeTeamPlayersCount = (value) => {
  if (!Number.isInteger(value) || value < 0) {
    return null;
  }
  return value;
};

export const isMondialiOpeningCeremonyWindowActive = (nowMs = Date.now()) => (
  nowMs >= MONDIALI_OPENING_CEREMONY_START_UTC_MS
  && nowMs < MONDIALI_OPENING_CEREMONY_END_UTC_MS
);

export const getMondialiOpeningCeremonySeenKey = (userId) => {
  if (!isNonEmptyString(userId)) {
    return null;
  }
  return `${MONDIALI_OPENING_CEREMONY_SEEN_KEY_PREFIX}:${userId.trim()}`;
};

export const hasSeenMondialiOpeningCeremonyModal = (userId = getUserId()) => {
  const key = getMondialiOpeningCeremonySeenKey(userId);
  if (!key) {
    return false;
  }
  return safeLocalStorageGetItem(key) !== null;
};

export const markMondialiOpeningCeremonyModalSeen = (userId = getUserId()) => {
  const key = getMondialiOpeningCeremonySeenKey(userId);
  if (!key) {
    return;
  }
  safeLocalStorageSetItem(key, Date.now().toString());
};

export const getMondialiOpeningCeremonyVariant = (mondiali) => {
  if (!mondiali || typeof mondiali !== 'object') {
    return null;
  }

  if (mondiali.is_registered === false) {
    return 'unregistered';
  }

  if (mondiali.is_registered !== true) {
    return null;
  }

  if (
    !isNonEmptyString(mondiali.username)
    || !isNonEmptyString(mondiali.country_alpha2)
    || !isNonEmptyString(mondiali.country_name_it)
  ) {
    return null;
  }

  const teamPlayersCount = normalizeTeamPlayersCount(mondiali.team_players_count);
  if (teamPlayersCount === null) {
    return null;
  }

  return teamPlayersCount >= 5 ? 'registered_large' : 'registered_small';
};

export const shouldShowMondialiOpeningCeremonyModal = ({
  pathname,
  mondiali,
  nowMs = Date.now(),
  userId = getUserId(),
}) => {
  if (pathname !== '/') {
    return false;
  }

  if (!isMondialiOpeningCeremonyWindowActive(nowMs)) {
    return false;
  }

  if (hasSeenMondialiOpeningCeremonyModal(userId)) {
    return false;
  }

  return getMondialiOpeningCeremonyVariant(mondiali) !== null;
};
